import { useQuery } from '@tanstack/react-query';
import type { ChangeStatus, ID } from '@proofroom/schema';
import { documents, drafts, projects } from './endpoints';

export const keys = {
  projects: ['projects'] as const,
  projectDocuments: (id: ID) => ['projects', id, 'documents'] as const,
  document: (id: ID) => ['documents', id] as const,
  changes: (id: ID, status?: ChangeStatus) => ['documents', id, 'changes', status ?? 'all'] as const,
  threads: (id: ID, draftId?: ID) => ['documents', id, 'threads', draftId ?? 'all'] as const,
  audit: (id: ID) => ['documents', id, 'audit'] as const,
  feedback: (id: ID) => ['documents', id, 'feedback'] as const,
  draft: (id: ID) => ['drafts', id] as const,
  snapshot: (id: ID) => ['drafts', id, 'snapshot'] as const,
  effectiveStories: (id: ID) => ['drafts', id, 'stories', 'effective'] as const,
};

export const useProjects = () => useQuery({ queryKey: keys.projects, queryFn: projects.list, refetchInterval: 15_000, refetchOnWindowFocus: true });
export const useProjectDocuments = (id: ID) => useQuery({ queryKey: keys.projectDocuments(id), queryFn: () => projects.documents(id), refetchInterval: 15_000, refetchOnWindowFocus: true });
export const useDocument = (id: ID) => useQuery({ queryKey: keys.document(id), queryFn: () => documents.get(id) });
export const useChanges = (id: ID, status?: ChangeStatus) => useQuery({ queryKey: keys.changes(id, status), queryFn: () => documents.changes(id, status) });
export const useThreads = (id: ID, draftId?: ID) => useQuery({ queryKey: keys.threads(id, draftId), queryFn: () => documents.threads(id, draftId) });
export const useAudit = (id: ID) => useQuery({ queryKey: keys.audit(id), queryFn: () => documents.audit(id, 200) });
export const useFeedback = (id: ID) => useQuery({ queryKey: keys.feedback(id), queryFn: () => documents.feedback(id) });
export const useDraft = (id: ID) => useQuery({ queryKey: keys.draft(id), queryFn: () => drafts.get(id) });
export const useSnapshot = (id: ID) => useQuery({ queryKey: keys.snapshot(id), queryFn: () => drafts.snapshot(id), staleTime: Infinity, gcTime: 10 * 60 * 1000 });
